<template>
  <v-app class="app-transparent-bg">
    <v-slide-x-transition mode="out-in">
      <router-view />
    </v-slide-x-transition>

    <v-offline @detected-condition="amIOnline" />
    <v-snackbar
      :value="!$store.state.isOnline"
      color="error"
      :timeout="-1"
      top
      right
    >
      <v-icon color="white" left>
        mdi-earth-off
      </v-icon>
      Vous n'êtes pas connecté, veuillez vérifier votre connexion internet!
    </v-snackbar>
    <error-handler />
  </v-app>
</template>

<script>
import ErrorHandler from "@/components/utils/ErrorHandler"
import VOffline from "v-offline"
export default {
  components: {
    VOffline,
    ErrorHandler
  },
  data: () => ({
    onLine: true
  }),
  methods: {
    amIOnline(e) {
      this.$store.commit(e ? "online" : "offline")
    }
  }
}
</script>
<style lang="scss">
.app-transparent-bg {
  background-color: transparent !important;
}
</style>
